import React, { useEffect, useState } from "react";
import styles from "./Products.module.scss";
import { Table, Modal, Button } from 'react-bootstrap';
import { useHttp } from "../../../hooks/http.hook";
import { useMessageError, useMessageSuccess } from '../../../hooks/message.hook';
import { getAdminProductsOperation } from "../../../store/products/operations";
import { getAdminProductsSelector } from "../../../store/products/selectors";
import Product from "./Product/Product";
import Container from "../../../components/Container/Container";
import BurgerMenu from '../../../components/BurgerMenu/BurgerMenu';
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../../../components/Pagination/Pagination";
import ProductsGrid from "./ProductsGrid";

const Products = () => {
    const dispatch = useDispatch();
    // Из за того, что используется редакс, не правильно отображает данные в пагинации, нужно посмотреть как исправить
    // const products = useSelector(getAdminProductsSelector)
    const [products, setProducts] = useState([]);
    const { request } = useHttp();
    const messageError = useMessageError();
    const messageSuccess = useMessageSuccess();
    const [showModal, setShowModal] = useState(false);
    const [showDel, setShowDel] = useState(false);
    const [delId, setDelId] = useState();
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [categories, setCategories] = useState([]);
    const [brands, setBrands] = useState([]);
    const [startPage, setStartPage] = useState(1);
    const perPage = 50;
    const [refreshOrders, setRefreshOrders] = useState(true);
    const [activeTab, setActiveTab] = useState('all');
    const [searchInput, setSearchInput] = useState('');
    const [productsCount, setProductsCount] = useState({
        all: 0,
        active: 0,
        inactive: 0,
        withDiscount: 0
    })
    const [productsQuantity, setProductsQuantity] = useState(0)
    let ordersFilter = {};

    // const startIndex = (startPage - 1) * perPage;
    // const endIndex = startIndex + perPage;
    // let productsToDisplay = filteredProducts.slice(startIndex, endIndex);
    // if (searchInput === '') {
    //     ordersFilter = { perPage, startPage };
    // } else {
    //     ordersFilter = { perPage, startPage, find: searchInput };
    // }

    const search = (event) => {
        setSearchInput(event);
    }

    useEffect(() => {
        fetchProductsData(1, searchInput)
    }, [activeTab])


    const fetchProductsData = async (page, find = "", tab = activeTab) => {
        try {
            let reqUrlCount = ""
            let reqUrlProducts = ""
            // Використовуємо переданий tab або поточний activeTab
            const serverTab = tab;
            
            if (find.length > 0) {
                reqUrlProducts = `admin/products/getall?startPage=${page}&perPage=${perPage}&productStatus=${serverTab}&find=${find}`
                reqUrlCount = `admin/products/get/count?find=${find}`
            } else {
                reqUrlProducts = `admin/products/getall?startPage=${page}&perPage=${perPage}&productStatus=${serverTab}`
                reqUrlCount = `admin/products/get/count`
            }
            const reqCount = await request(reqUrlCount, "GET");
            const reqProducts = await request(reqUrlProducts, "GET");
            
            setProductsCount({
                all: reqCount.data.all,
                active: reqCount.data.active,
                inactive: reqCount.data.inactive,
                withDiscount: reqCount.data.withDiscount
            });
            setProducts(reqProducts)
        } catch (error) {
            console.error('Ошибка загрузки данных:', error);
            messageError(`Ошибка загрузки данных: ${error}`);
        }
    };

    const fetchCategories = async () => {
        try {
            const data = await request('admin/categories/getall', 'GET');
            setCategories(data.data);
        } catch (error) {
            messageError(error);
        }
    };

    const fetchBrands = async () => {
        try {
            const data = await request('admin/brands/getall', 'GET');
            setBrands(data.data);
        } catch (error) {
            messageError(error);
        }
    };

    const handleDeleteAccess = async () => {
        setShowDel(false);
        try {
            const data = await request(`admin/products/delete/${delId}`, 'DELETE');
            messageSuccess(data.message);
            setDelId("");
            // dispatch(getAdminProductsOperation(ordersFilter));
            fetchProductsData(1)
        } catch (error) {
            messageError(error);
        }
    };
    const serchHandleer = () => {
        if (searchInput) {
            fetchProductsData(1, searchInput)
        } else {
            fetchProductsData(1)
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            serchHandleer();
        }
    };

    useEffect(() => {
        // dispatch(getAdminProductsOperation(ordersFilter));
        // fetchProductsData(1)
        setRefreshOrders(false);
    }, [refreshOrders, startPage]); // Оновлення продуктів лише при монтуванні компоненту


    useEffect(() => {
        fetchCategories();
        fetchBrands();
        fetchProductsData(1);
    }, []);

    const handleTabChange = (newTab) => {
        setActiveTab(newTab);
        setStartPage(1); // Скидуємо на першу сторінку при зміні вкладки
        fetchProductsData(1, searchInput, newTab); // Завантажуємо дані з новим фільтром
    };

    useEffect(() => {
        if (activeTab === "all") {
            setProductsQuantity(productsCount.all)
        } else if (activeTab === "active") {
            setProductsQuantity(productsCount.active)
        } else if (activeTab === "inactive") {
            setProductsQuantity(productsCount.inactive)
        } else if (activeTab === "withDiscount") {
            setProductsQuantity(productsCount.withDiscount)
        }
    }, [activeTab, productsCount]);
    // useEffect(() => {
    //     if (ordersFilter.find) {
    //         serchHandleer()
    //     } else {
    //         fetchProductsData()
    //     }
    // }, [searchInput])

    const handleDelete = async (id) => {
        setShowDel(true);
        setDelId(id);
        fetchProductsData(1);
    };

    // useEffect(() => {
    //     const totalPages = Math.ceil(filteredProducts.length / perPage);

    //     if (startPage > totalPages && totalPages > 0) {
    //         setStartPage(1);
    //     }
    // }, [filteredProducts.length, startPage, perPage]);

    // useEffect(() => {
    //     console.log("BBBB")
    //     console.log("BBBB")
    //     console.log("BBBB")
    //     console.log(startPage)
    //     fetchProductsData()
    // }, startPage)

    const changePage = (number) => {
        setStartPage(number)
        fetchProductsData(number)
    }

    const handleActive = async (id) => {
        try {
            const data = await request(`admin/products/active/${id}`, 'PUT');
            messageSuccess(data.message);
            // dispatch(getAdminProductsOperation(ordersFilter));
            fetchProductsData(1)
        } catch (error) {
            messageError(error);
        }
    };

    const handleCreate = () => {
        setShowModal(true);
        setSelectedProduct(null);
    };
    const handleEdit = (id) => {
        setSelectedProduct(id);
        setShowModal(true);
        // fetchProductsData(1)
    };
    const handleCloseModal = async (success) => {
        setShowModal(false);
        if (success) {
            fetchProductsData(1, searchInput)
            // dispatch(getAdminProductsOperation());
        }
    };
    const handleCloseDel = () => {
        setShowDel(false);
        setDelId("");
    }
    return (
        <>
            <section>
                <BurgerMenu />
                <Container>
                    <h1>Всі Продукти</h1>
                    {/* <p>Kількість позицій: <span>{products.length}</span></p> */}
                    <div className="d-flex justify-content-between mb-5">
                        <div className={styles.filter}>
                            <div className={styles.filterWrapper}>
                                <div>
                                    <input className="form-control" onChange={(e) => setSearchInput(e.target.value.trim())}
                                        onKeyDown={handleKeyDown} name='search' type='text' placeholder="Пошук" tabIndex='0' />
                                </div>
                                <Button variant="btn btn-outline-secondary" onClick={() => serchHandleer()}>Пошук</Button>
                            </div>
                        </div>
                        <div className='d-flex justify-content-end'>
                            <Button variant="dark" onClick={() => handleCreate()}>Створити</Button>{' '}
                        </div>
                    </div>

                    <div>
                        <h1>Товари</h1>
                        <ul className="nav nav-tabs mb-4">
                            <li className="nav-item">
                                <a
                                    className={`nav-link ${activeTab === 'all' ? 'active' : ''}`}
                                    onClick={() => handleTabChange('all')}
                                    href="#"
                                >
                                    Все товары ({productsCount.all})
                                </a>
                            </li>
                            <li className="nav-item">
                                <a
                                    className={`nav-link ${activeTab === 'active' ? 'active' : ''}`}
                                    onClick={() => handleTabChange('active')}
                                    href="#"
                                >
                                    Активные товары ({productsCount.active})
                                </a>
                            </li>
                            <li className="nav-item">
                                <a
                                    className={`nav-link ${activeTab === 'inactive' ? 'active' : ''}`}
                                    onClick={() => handleTabChange('inactive')}
                                    href="#"
                                >
                                    Неактивные товары ({productsCount.inactive})
                                </a>
                            </li>
                            <li className="nav-item">
                                <a
                                    className={`nav-link ${activeTab === 'withDiscount' ? 'active' : ''}`}
                                    onClick={() => handleTabChange('withDiscount')}
                                    href="#"
                                >
                                    Зі знижками ({productsCount.withDiscount})
                                </a>
                            </li>
                        </ul>
                        <ProductsGrid
                            products={products}
                            handleActive={handleActive}
                            handleEdit={handleEdit}
                            handleDelete={handleDelete}
                        />
                    </div>
                    <Pagination perPage={perPage} startPage={startPage} setPage={changePage} productsQuantity={productsQuantity} />

                    {/* Modal for editing category */}
                    <Modal show={showModal} onHide={handleCloseModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>{selectedProduct ? "Редагування" : "Створення"} Продукту</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {selectedProduct && <Product categories={categories} brands={brands} create={false} edit={true} id={selectedProduct} onSubmit={()=>{handleCloseModal(true)}} close={handleCloseModal} />}
                            {!selectedProduct && <Product categories={categories} brands={brands} create={true} edit={false} id={selectedProduct} onSubmit={()=>{handleCloseModal(true)}} close={handleCloseModal} />}
                        </Modal.Body>
                    </Modal>
                    <Modal show={showDel} onHide={handleCloseDel}>
                        <Modal.Header closeButton>
                            <Modal.Title>Видалити</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Button variant="danger" onClick={() => handleDeleteAccess()}>Видалити</Button>
                        </Modal.Body>
                    </Modal>
                </Container>
            </section>
        </>
    )
}

export default Products;
